import script from "./lgin.vue?vue&type=script&setup=true&lang=js"
export * from "./lgin.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__